module.exports = __webpack_public_path__ + "img/group.b7fa1924.png";